import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { useTheme } from "../context/ThemeContext";

function CustomTooltip({ active, payload, label, isPrice }) {
  if (!active || !payload || !payload.length) return null;
  const v = payload[0].value;
  return (
    <div className="border border-border bg-popover px-3 py-2 shadow-lg">
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="font-mono text-sm font-semibold">
        {isPrice ? "$" : ""}{Number(v).toLocaleString(undefined, { maximumFractionDigits: 6 })}
      </div>
    </div>
  );
}

export function PriceChart({ points, isPrice = false, height = 300 }) {
  const { theme } = useTheme();
  if (!points || points.length === 0) {
    return (
      <div className="flex items-center justify-center border border-dashed border-border text-muted-foreground text-sm" style={{ height }} data-testid="chart-empty">
        No chart data available.
      </div>
    );
  }
  const data = points.map((p) => {
    const d = new Date(isPrice ? p.t : p.t + "T00:00:00");
    return {
      label: d.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(isPrice && points.length <= 60 ? { hour: "2-digit" } : {}) }),
      value: p.v,
    };
  });
  const first = data[0].value;
  const last = data[data.length - 1].value;
  const up = last >= first;
  const color = up ? "hsl(var(--success))" : "hsl(var(--danger))";

  return (
    <div data-testid="price-chart" style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 10, right: 8, left: 8, bottom: 0 }}>
          <defs>
            <linearGradient id="fill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.25} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="2 4" stroke={theme === "dark" ? "#27272a" : "#e2e8f0"} vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 10, fontFamily: "JetBrains Mono", fill: "hsl(var(--muted-foreground))" }} tickLine={false} axisLine={false} minTickGap={40} />
          <YAxis domain={["auto", "auto"]} tick={{ fontSize: 10, fontFamily: "JetBrains Mono", fill: "hsl(var(--muted-foreground))" }} tickLine={false} axisLine={false} width={54} tickFormatter={(v) => Number(v).toLocaleString(undefined, { maximumFractionDigits: 4, notation: "compact" })} />
          <Tooltip content={<CustomTooltip isPrice={isPrice} />} />
          <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2} fill="url(#fill)" dot={false} activeDot={{ r: 4 }} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
